<template>
  <md-field>
    <label>
      <slot name="label">Days of the week</slot>
    </label>
    <md-select multiple v-model="selectedValues" v-on:input="$listeners['input']">
      <toggle-all-option-component :value="selectedValues" :types="weekDays" @toggleAll="toggleAll"></toggle-all-option-component>
      <md-option v-for="type in weekDays" :key="type.id" :value="type.id">{{ type.label }}</md-option>
    </md-select>
  </md-field>
</template>

<script>
const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

import SelectMixins from '../../Inputs/SelectMixins'
import ToggleAllOptionComponent from '../../Inputs/ToggleAllOptionComponent.vue'
export default {
  name: 'WeekDaysSelect',
  components: { ToggleAllOptionComponent },
  mixins: [SelectMixins],
  props: {
    value: Array,
  },
  data() {
    return {
      weekDays: days.map((d) => {
        return {
          id: d.toUpperCase(),
          label: d,
        }
      }),
    }
  },
  methods: {
    toggleAll() {
      if (this.selectedValues.length == this.weekDays.length) this.selectedValues = []
      else this.selectedValues = this.weekDays.map((i) => i[this.bindedAttr])
    },
  },
}
</script>
